import { render, staticRenderFns } from "./Func53PendenciaNotificacoes.vue?vue&type=template&id=3bceb7fc"
import script from "./Func53PendenciaNotificacoes.vue?vue&type=script&lang=js"
export * from "./Func53PendenciaNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./Func53PendenciaNotificacoes.vue?vue&type=style&index=0&id=3bceb7fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports